export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/c2c19abb7281dd714280457d4eb4b776.png";